import { styled } from 'styled-components';
import { Button } from 'antd';

export const DropdownButton = styled(Button)`
  font-size: 0.8rem;
  font-weight: 600;
  border: none;
  box-shadow: none;
  min-width: 5rem;
  align-self: center;
`;

export const MenuButton = styled(Button)`
  font-size: 0.8rem;
  font-weight: 600;
  width: 100%;
  text-align: left;
  background-color: ${props => props.theme.colors.languageMenuButtonBackground};
  color: ${props => props.theme.colors.defaultTextColor};
  border: none;
  box-shadow: none;

  :hover,
  :active,
  :focus {
    color: ${props => props.theme.colors.primaryButtonHover};
    border: none;
    box-shadow: none;
  }
`;

export const FlagIcon = styled.img`
  width: 2rem;
  height: 1.6rem;
  margin-right: 0.3rem;
`;
